import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";

export default class VanityBacksplash extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_backsplash';
    this.partName = 'Backsplash';
    this.translateId = "visualizer.bathroom.vanity.vanity_backsplash";
    this.dbName = 'Backsplash';
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityBacksplash())
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    conditions.push({
      propName: "VanitySize",
      propValue: vanityParent.getCounterTopSize()
    })
    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      const zIndex = zIndexes.Vanity.VanityBacksplash;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
    }
  }
}
